<template>
    <div :class="{ 'disabled-status': !status.isEnabled }">
        <div class="d-flex">
            <AppStatusColoredRect :color="status.color" :outer="false" :size="20"/>
            <div class="flex-grow-1 align-self-center pl-2">
                {{ status.name }}
            </div>
            <div v-if="!status.isEnabled" class="px-3 text-muted">
                Disabled
            </div>
            <div class="align-self-center text-center">
                <span data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      class="list-group-item-btn">
                    <i class="fas fa-sm fa-ellipsis-h"></i>
                </span>
                <div class="dropdown-menu dropdown-menu-right">
                    <div @click="editStatus" class="dropdown-item">
                        Edit
                    </div>
                    <div class="dropdown-divider"></div>
                    <div @click="deleteStatus" class="dropdown-item text-danger">
                        Delete
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppStatusColoredRect from '@/components/shared/AppStatusColoredRect'

export default {
    name: 'DocStatusRow',
    components: {AppStatusColoredRect},
    props: {
        status: {
            type: Object,
            required: true
        }
    },
    methods: {
        editStatus() {
            this.$emit('edit', this.status)
        },

        deleteStatus() {
            this.$emit('delete', this.status)
        }
    }
}
</script>

<style lang="scss" scoped>
.disabled-status {
    color: $color-grey-light;
}
</style>
